<template>
    <v-tooltip bottom>
        <v-btn slot="activator"
            text-color="white"
            class="d-inline bg_white"
            @click.native="selecionarTodosItens()"
        >
        <svg  class="customIcon i_header" viewBox="0 0 24 24">
            <path fill="#000000" d="M20,16V10H22V16A2,2 0 0,1 20,18H8C6.89,18 6,17.1 6,16V4C6,2.89 6.89,2 8,2H16V4H8V16H20M10.91,7.08L14,10.17L20.59,3.58L22,5L14,13L9.5,8.5L10.91,7.08M16,20V22H4A2,2 0 0,1 2,20V7H4V20H16Z" />
        </svg>
        <small>Selecionar todas: </small>
        <small class="selected_Total" >{{this.table.selected.length}}/{{this.table.qnt_total_notas}}</small>
        </v-btn>
        <span>Notas selecionadas / Total de notas</span>
    </v-tooltip>

</template>

<script>
export default {
  props: ["selected", "table"],
  data: () => ({
    dialog: false
  }),
  methods: {
    selecionarTodosItens: function() {
      this.table.selecionarTodosItens('primeiro_check')
      let selected = this.table.selecionarTodosItens('all');
      this.$emit("getSelected", selected);
    }
  }
};
</script>
<style scoped>
.lista-colunas {
  width: 46%;
  margin: 0 2% 0 0;
}
.lista-colunas ul {
  height: 40vh;
  list-style-type: none;
  overflow: auto;
}
#colItensAtivas i {
  transform: rotateY(180deg);
}
.selected_Total {
  width: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnSelectAll/btnSelectAll.vue